import React, { Suspense, useEffect, useState } from 'react';
import { ApolloProvider, useQuery } from '@apollo/client';
import gql from 'graphql-tag';
import ReactDOM from 'react-dom';
import ShippingPrice from './ShippingPrice';
const QUERY = gql `
  query ShippingPriceLoaderQuery(
    $sellerProductModelIds: String
    $prefectureCode: String
    $quantities: String
  ) {
    calculateShippingPrice {
      calculateShippingPrice(
        sellerProductModelIds: $sellerProductModelIds
        prefectureCode: $prefectureCode
        quantities: $quantities
      ) {
        itemShippingPrices {
          sellerProductModelId
          shippingPrice
        }
        totalShippingPrice
      }
    }
  }
`;
const ShippingPriceLoader = (props) => {
    let [prefectureCode, setPrefectureCode] = useState(props.prefectureCode);
    let [quantities, setQuantities] = useState(props.quantities);
    let { loading, error, data, refetch, fetchMore } = useQuery(QUERY, {
        variables: {
            sellerProductModelIds: props.modelIds,
            prefectureCode: prefectureCode,
            quantities: quantities,
        },
    });
    useEffect(() => {
        if (data) {
            updateCartTotal();
        }
    }, [data]);
    const getTotalShippingPrice = () => {
        if (data && data.calculateShippingPrice && data.calculateShippingPrice.calculateShippingPrice) {
            return data.calculateShippingPrice.calculateShippingPrice.totalShippingPrice;
        }
        else {
            return 0;
        }
    };
    const numberWithCommas = (x) => {
        return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    };
    const updateCartTotal = () => {
        // mp-web https://order.test.aperza.com/cart (to update total)
        let totalPriceNoShippingFee = document.getElementById('cart-totalPriceNoShippingFee');
        if (totalPriceNoShippingFee) {
            totalPriceNoShippingFee = parseInt(totalPriceNoShippingFee.textContent, 10);
            // smartphone + pc uses same class with different elements, update all
            const totalPrices = document.getElementsByClassName('cart-totalPriceWithShippingFee');
            for (let i = 0; i < totalPrices.length; i++) {
                let totalPrice = totalPrices.item(i);
                if (totalPrice) {
                    totalPrice.textContent =
                        '¥' + numberWithCommas(getTotalShippingPrice() + totalPriceNoShippingFee);
                }
            }
        }
    };
    const handlePrefectureChange = (e) => {
        setPrefectureCode(e.target.value);
    };
    const handleQuantityChange = (e) => {
        console.log('Handling quantity change', e.target.value);
        setQuantities(e.target.value);
    };
    useEffect(() => {
        if (document.getElementById('aperza-prefectures-for-shipping-price-component')) {
            let el = document.getElementById('aperza-prefectures-for-shipping-price-component');
            if (el) {
                el.addEventListener('change', handlePrefectureChange, false);
            }
        }
        if (document.getElementById('aperza-quantity-for-shipping-price-component')) {
            let el = document.getElementById('aperza-quantity-for-shipping-price-component');
            if (el) {
                el.addEventListener('change', handleQuantityChange, false);
            }
        }
        // if there are prefecture-class present, register those too
        const prefectureSelects = document.getElementsByClassName('aperza-prefectures-for-shipping-price-component-class');
        if (prefectureSelects && prefectureSelects !== 0) {
            for (let i = 0; i < prefectureSelects.length; i++) {
                let prefectureSelect = prefectureSelects.item(i);
                prefectureSelect.addEventListener('change', handlePrefectureChange, false);
            }
        }
        // if there are quantity-class present, register those too
        const quantitySelects = document.getElementsByClassName('aperza-quantity-for-shipping-price-component-class');
        if (quantitySelects && quantitySelects !== 0) {
            for (var i = 0; i < quantitySelects.length; i++) {
                let quantitySelect = quantitySelects.item(i);
                quantitySelect.addEventListener('change', handleQuantityChange, false);
            }
        }
        updateCartTotal();
        return () => {
            if (document.getElementById('aperza-prefectures-for-shipping-price-component')) {
                document.removeEventListener('change', handlePrefectureChange, false);
            }
            if (document.getElementById('aperza-quantity-for-shipping-price-component')) {
                document.removeEventListener('change', handleQuantityChange, false);
            }
            const prefectureSelects = document.getElementsByClassName('aperza-prefectures-for-shipping-price-component-class');
            if (prefectureSelects && prefectureSelects !== 0) {
                for (var i = 0; i < prefectureSelects.length; i++) {
                    let prefectureSelect = prefectureSelects.item(i);
                    prefectureSelect.removeEventListener('change', handlePrefectureChange, false);
                }
            }
            const quantitySelects = document.getElementsByClassName('aperza-quantity-for-shipping-price-component-class');
            if (quantitySelects && quantitySelects !== 0) {
                for (var i = 0; i < quantitySelects.length; i++) {
                    let quantitySelect = quantitySelects.item(i);
                    quantitySelect.removeEventListener('change', handleQuantityChange, false);
                }
            }
        };
    }, []);
    useEffect(() => {
        refetch({
            sellerProductModelIds: props.modelIds,
            prefectureCode: prefectureCode,
            quantities: quantities,
        });
    }, [prefectureCode, quantities]);
    if (loading)
        return React.createElement("div", null, "Loading");
    if (error)
        return React.createElement("div", null, error.message);
    if (!data ||
        !data.calculateShippingPrice ||
        !data.calculateShippingPrice.calculateShippingPrice) {
        console.log('Data is empty, not returning any shipping prices');
        return null;
    }
    if (!props.modelIds || !prefectureCode || !quantities) {
        console.log('Missing modelId/prefectureCode/quantity, not processing', {
            modelIds: props.modelIds,
            prefectureCode,
            quantities,
        });
        return null;
    }
    return React.createElement(ShippingPrice, { totalShippingPrice: getTotalShippingPrice() });
};
export default ShippingPriceLoader;
const renderShippingPrice = (apolloClient) => {
    // try to search by class - in case there are multiple components in single page (ie. cart for smartphone and pc)
    const shippingPriceComponents = document.getElementsByClassName('aperza-shipping-price-component-class');
    const shippingPriceComponent = document.getElementById('aperza-shipping-price-component');
    if (shippingPriceComponents && shippingPriceComponents.length !== 0) {
        // loop through all price components
        for (let i = 0; i < shippingPriceComponents.length; i++) {
            let currentShippingPriceComponent = shippingPriceComponents.item(i);
            if (currentShippingPriceComponent) {
                let dataset = currentShippingPriceComponent.dataset;
                if (dataset) {
                    let modelIds = dataset.modelIdCsv;
                    let prefectureCode = dataset.prefectureCode;
                    let quantities = dataset.quantityCsv;
                    ReactDOM.render(React.createElement(ApolloProvider, { client: apolloClient },
                        React.createElement(Suspense, { fallback: React.createElement("div", null) },
                            React.createElement(ShippingPriceLoader, { modelIds: modelIds, prefectureCode: prefectureCode, quantities: quantities }))), currentShippingPriceComponent);
                }
            }
        }
    }
    else if (shippingPriceComponent) {
        // just look for single id
        let modelIds = shippingPriceComponent.dataset.modelIdCsv;
        let prefectureCode = shippingPriceComponent.dataset.prefectureCode;
        let quantities = shippingPriceComponent.dataset.quantityCsv;
        ReactDOM.render(React.createElement(ApolloProvider, { client: apolloClient },
            React.createElement(Suspense, { fallback: React.createElement("div", null) },
                React.createElement(ShippingPriceLoader, { modelIds: modelIds, prefectureCode: prefectureCode, quantities: quantities }))), shippingPriceComponent);
    }
};
export { renderShippingPrice };
